/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of GameTimeFootage Inc.
 #*
 #* Copyright NextPro 2019. All Rights Reserved.
 #*
 #*===================================================================
 */

import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { concat, Observable, of, Subject } from 'rxjs';
import { catchError, distinctUntilChanged, switchMap, tap } from 'rxjs/operators';

import { FormHelpersService, ModalService, UserCommitmentService } from 'app/shared/services';

@Component({
  selector: '[userCommitmentModalGeneral]',
  templateUrl: './user-commitment-modal.component.html',
  styleUrls: ['./user-commitment-modal.component.scss'],
})
export class UserCommitmentModalComponent implements OnInit {
  @Output() closeModal: EventEmitter<any> = new EventEmitter();

  isEditMode = false;
  loading = true;
  userCommitmentForm: FormGroup;
  summaryErrorMessage = null;
  commitmentOptions: any;
  commitments = [];
  selectedCommitment = {};
  customCollegeName: string;
  commitmentLoading = false;
  commitmentInput$ = new Subject<string>();
  commitmentsList$: Observable<any>;

  constructor(
    private modalService: ModalService,
    public fhs: FormHelpersService,
    private userCommitmentService: UserCommitmentService
  ) {
    this.userCommitmentForm = new FormGroup({
      commitedCollegeId: new FormControl(null),
    });
  }

  ngOnInit() {
    this.loadCommitments();
  }

  close() {
    this.modalService.hideModal();
    this.closeModal.emit(null);
  }

  onSubmit($event) {
    $event.preventDefault();
    this.summaryErrorMessage = null;
    const selectedCollegeId = this.userCommitmentForm.value.commitedCollegeId;

    if (!this.customCollegeName && !selectedCollegeId) {
      this.summaryErrorMessage = 'Please select a college name';
      return;
    }

    let newCommitment;
    // if user set a custom college name
    if (this.customCollegeName && !selectedCollegeId) {
      newCommitment = {
        custom: true,
        name: this.customCollegeName,
      };
    } else {
      newCommitment = {
        ...this.selectedCommitment,
        custom: false,
        id: this.userCommitmentForm.value.commitedCollegeId,
      };
    }

    this.closeModal.emit(newCommitment);
    this.modalService.hideModal();
  }

  onCommitmentChanged(commitment) {
    if (commitment) {
      this.selectedCommitment = { ...commitment };
    } else {
      this.selectedCommitment = {};
    }
  }

  setCustomCommitment(value) {
    this.customCollegeName = value;
  }

  private loadCommitments() {
    const initialCommitmentsList = [];

    this.commitmentsList$ = concat(
      of(initialCommitmentsList), // default items
      this.commitmentInput$.pipe(
        distinctUntilChanged(),
        tap(() => (this.commitmentLoading = true)),
        switchMap((term) =>
          this.userCommitmentService.search(term).pipe(
            catchError(() => of([])), // empty list on error
            tap(() => (this.commitmentLoading = false))
          )
        )
      )
    );
  }
}
